import { Shader } from "./Shader";
import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const links = [
  ["Bernardo", "https://x.com/equemeuputo"],
  ["Marcos", "https://x.com/marcospereeira"],
];

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <div className="absolute -z-1 h-full w-full">
      <Shader className="h-full w-full" />
    </div>

    <div className="flex h-full w-full items-center justify-center text-center">
      <h1 className="mb-m bg-clip-text text-[max(15vw,7rem)] leading-[1.2] text-white">
        HESO
        <br />
        YAM
      </h1>
    </div>

    <div className="text-l bg-black p-s text-white md:p-l md:text-xl">
      <p>A software studio based in northern Portugal</p>
      <p>
        by{" "}
        {links.map((x, i) => (
          // eslint-disable-next-line @eslint-react/no-array-index-key
          <span key={i}>
            {i > 0 && " and "}
            <a href={x[1]} className="font-bold underline">
              {x[0]}
            </a>
          </span>
        ))}
      </p>
    </div>
  </StrictMode>,
);
